/** RF and its simulator own scanner/keyboard input; preserve editable-control isolation elsewhere. */
export const allowGlobalShortcut = (event: KeyboardEvent, pathname: string): boolean => {
  if (event.defaultPrevented || /^\/rf(?:\/|$)/.test(pathname) || /^\/dev\/rf-preview(?:\/|$)/.test(pathname))
    return false
  const target = event.target
  return !(
    target instanceof HTMLElement &&
    (target.isContentEditable ||
      target.closest(
        'input,select,textarea,[contenteditable="true"],[contenteditable=""],[contenteditable="plaintext-only"]'
      ))
  )
}
